var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"Box"},[_c('div',{staticStyle:{"position":"relative"}},[_c('el-progress',{attrs:{"type":"circle","width":60,"percentage":_vm.percentage,"show-text":false,"stroke-width":"4"}}),_c('div',{staticClass:"time"},[(_vm.countdown > 0)?_c('h2',[_vm._v(_vm._s(_vm.countdown)+"秒")]):_vm._e()])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }